import React, { FC, useContext, useEffect, useState } from 'react';

import Paper from '@material-ui/core/Paper';

import { GlobalContext } from '../../store';
import { IClub } from '../../store/player/clubs/store';

import { toHandicap } from '../../contrib/Utils/toHandicap';

interface IProps {
  title?: string;
  clubId?: string;
}

const HandicapIndex: FC<IProps> = props => {
  const { clubId, title } = props;

  const { clubs, user } = useContext(GlobalContext);

  const [club, setClub] = useState<IClub>();
  const [clubHandicap, setclubHandicap] = useState<string>();
  const [currentHandicap, setCurrentHandicap] = useState<string>();
  const [lowHandicap, setLowHandicap] = useState<string>();

  useEffect(() => {
    if (clubId && clubs) {
      setClub(clubs[Number(clubId)]);
    }
  }, [clubs, clubId]);

  useEffect(() => {
    if (club) {
      setclubHandicap(toHandicap(club.index));
    }
  }, [club]);

  useEffect(() => {
    if (user) {
      setCurrentHandicap(toHandicap(user.profile.handicapCurrent));

      setLowHandicap(toHandicap(user.profile.handicapLow));
    }
  }, [user]);

  return (
    <div className="handicap-index">
      <Paper elevation={1} className="paper">
        <h4>{!!title ? title : 'My Indexes'}</h4>

        <div className={`pills ${club ? 'small' : ''}`}>
          {club && (
            <div className={clubHandicap === 'TBD' ? 'inverted' : ''}>
              <span className="value">{clubHandicap}</span>

              <span className="label">
                CLUB <br />
                INDEX
              </span>
            </div>
          )}

          {/* disabled due to https://code.talpor.com/club15/frontend/-/issues/889 */}
          {false && (
            <div className={currentHandicap === 'TBD' ? 'inverted' : ''}>
              <span className="value">{currentHandicap}</span>

              <span className="label">
                CURRENT <br />
                INDEX
              </span>
            </div>
          )}

          <div className={lowHandicap === 'TBD' ? 'inverted' : ''}>
            <span className="value">{lowHandicap}</span>

            <span className="label">
              LOW <br />
              INDEX
            </span>
          </div>
        </div>
      </Paper>
    </div>
  );
};

export { HandicapIndex };
